export const userRes = {
  result: {
    _id: '60b8e01d4e5ee20015ff7314',
    id: '60b8e01d4e5ee20015ff7314',
    email: 'admin@gmail.com',
    name: 'admin',
    imageUrl:
      'https://res.cloudinary.com/social-media-simi/image/upload/v1622728732/jacdcws6xcvedhkaf62u.png',
    cloudinaryId: 'jacdcws6xcvedhkaf62u',
    __v: 0,
  },
};

export const postsRes = [
  {
    creatorImage:
      'https://res.cloudinary.com/social-media-simi/image/upload/v1622739072/hbl8nlsm8mvrqbklqxnd.png',
    likes: ['60b908814e5ee20015ff7317', '60ba0ab5a440350015c1160b', '106082252769044628339'],
    createdAt: '2021-06-03T16:54:04.225Z',
    _id: '60b9092c4e5ee20015ff731a',
    title: 'Java vs .NET',
    description: 'fight of the century',
    creatorName: 'Zordon',
    creator: '60b908814e5ee20015ff7317',
    selectedFile:
      'https://res.cloudinary.com/social-media-simi/image/upload/v1622739243/s8pi1wetwqiv36qg9c3z.png',
    cloudinaryId: 's8pi1wetwqiv36qg9c3z',
    comments: [
      {
        creatorImage:
          'https://lh3.googleusercontent.com/a-/AOh14GgXwPeTGElOol13877EYgAlpL6xA69_i3MEJ6KfcQ=s96-c',
        _id: '60d383ac1c99adcc146e18e9',
        text: 'hello',
        creator: '106082252769044628339',
        creatorName: 'Szymon Popielarz',
        created: '2021-06-23T18:55:40.239Z',
      },
      {
        creatorImage:
          'https://res.cloudinary.com/social-media-simi/image/upload/v1623003341/vi3rai9gp0xf6s7ou989.png',
        _id: '60bd10e696d73b0015a7b9ff',
        text: 'ddd',
        creator: '60bd10ce96d73b0015a7b9fe',
        creatorName: 'asc',
        created: '2021-06-06T18:16:06.173Z',
      },
      {
        creatorImage:
          'https://res.cloudinary.com/social-media-simi/image/upload/v1622973730/fsslb4ljg0shgdvbtc0m.png',
        _id: '60bc9d4235fcec001558e37c',
        text: "'>alert(1);",
        creator: '60bc9d2235fcec001558e378',
        creatorName: 'a',
        created: '2021-06-06T10:02:42.203Z',
      },
      {
        creatorImage:
          'https://res.cloudinary.com/social-media-simi/image/upload/v1622805172/ee6rkwyqge35die00bqk.png',
        _id: '60ba0abaa440350015c1160c',
        text: 'swf',
        creator: '60ba0ab5a440350015c1160b',
        creatorName: 'nfy',
        created: '2021-06-04T11:12:58.550Z',
      },
      {
        creatorImage:
          'https://res.cloudinary.com/social-media-simi/image/upload/v1622739072/hbl8nlsm8mvrqbklqxnd.png',
        _id: '60b909354e5ee20015ff731b',
        text: 'nice',
        creator: '60b908814e5ee20015ff7317',
        creatorName: 'Zordon',
        created: '2021-06-03T16:54:13.413Z',
      },
    ],
    __v: 5,
  },
  {
    creatorImage:
      'https://res.cloudinary.com/social-media-simi/image/upload/v1622728732/jacdcws6xcvedhkaf62u.png',
    likes: ['60ba0ab5a440350015c1160b', '60bc9d2235fcec001558e378', '106082252769044628339'],
    createdAt: '2021-06-03T14:02:47.960Z',
    _id: '60b8e1074e5ee20015ff7315',
    title: 'Hello',
    description: 'Welcome on our website! ',
    creatorName: 'admin',
    creator: '60b8e01d4e5ee20015ff7314',
    selectedFile:
      'https://res.cloudinary.com/social-media-simi/image/upload/v1622728967/rnqkvpwqxdbfpzszfi6i.png',
    cloudinaryId: 'rnqkvpwqxdbfpzszfi6i',
    comments: [
      {
        creatorImage:
          'https://lh3.googleusercontent.com/a-/AOh14GgXwPeTGElOol13877EYgAlpL6xA69_i3MEJ6KfcQ=s96-c',
        _id: '60ccb9ddec85470015fb1b53',
        text: 'ESSA',
        creator: '106082252769044628339',
        creatorName: 'Szymon Popielarz',
        created: '2021-06-18T15:21:01.640Z',
      },
      {
        creatorImage:
          'https://res.cloudinary.com/social-media-simi/image/upload/v1622739072/hbl8nlsm8mvrqbklqxnd.png',
        _id: '60b9089e4e5ee20015ff7319',
        text: 'pog',
        creator: '60b908814e5ee20015ff7317',
        creatorName: 'Zordon',
        created: '2021-06-03T16:51:42.503Z',
      },
      {
        creatorImage:
          'https://res.cloudinary.com/social-media-simi/image/upload/v1622739072/hbl8nlsm8mvrqbklqxnd.png',
        _id: '60b908974e5ee20015ff7318',
        text: 'Hello World!',
        creator: '60b908814e5ee20015ff7317',
        creatorName: 'Zordon',
        created: '2021-06-03T16:51:35.180Z',
      },
      {
        creatorImage:
          'https://res.cloudinary.com/social-media-simi/image/upload/v1622728732/jacdcws6xcvedhkaf62u.png',
        _id: '60b8e1184e5ee20015ff7316',
        text: 'You can write comments here',
        creator: '60b8e01d4e5ee20015ff7314',
        creatorName: 'admin',
        created: '2021-06-03T14:03:04.426Z',
      },
    ],
    __v: 4,
  },
];
